<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nuevo') + ' método de pago'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="saveEntity()">

    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-8">

        <div class="grid grid-cols-1 gap-6">
            <custom-input [autofocus]="true" label="Nombre" type="text" placeholder="Ej: Contado, 30 días..."
                (tabEvent)="addAdditionalConfig()" [formControlItem]="saveForm.get('name')">
            </custom-input>
        </div>

        <section class="p-6 bg-neutral-50 rounded-2xl border-2 border-black">
            <div class="flex justify-between items-center mb-3">
                <h3 class="text-xs font-black uppercase tracking-[0.2em] text-black flex items-center">
                    <span class="mr-2">⚙️</span> Configuración de plazos
                </h3>

                <div class="px-3 py-1 rounded-full border-2 border-black text-xs font-bold"
                    [class.bg-green-400]="totalPercentage === 100"
                    [class.bg-red-400]="totalPercentage !== 100 && configurationsArray.length > 0">
                    Total: {{ totalPercentage }}%
                </div>
            </div>

            <div class="space-y-4" formArrayName="configurations">
                @for (group of configurationsArray.controls; track $index; let i = $index) {
                <div [formGroupName]="i"
                    class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-white border-2 border-black rounded-xl">
                    <custom-input #inputDays label="Días tras factura" type="number" placeholder="0"
                        [formControlItem]="group.get('days')">
                    </custom-input>

                    <custom-input label="Porcentaje %" decimal unit="%" placeholder="100"
                        [formControlItem]="group.get('percent')" (tabEvent)="addAdditionalConfig($index)">

                    </custom-input>
                </div>
                }

                @if(configurationsArray.errors?.['not100'] && configurationsArray.dirty){
                <div class="p-3 bg-black text-white text-xs font-bold rounded-lg text-center">
                    ⚠️ LA SUMA DE LOS PORCENTAJES DEBE SER EXACTAMENTE 100% (ACTUAL: {{totalPercentage}}%)
                </div>
                }

            </div>



            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
                <button type="button"
                    class="group flex items-center justify-center p-1 text-sm font-bold text-black bg-white border-2 border-black rounded-xl hover:bg-black hover:text-white transition-all duration-200"
                    (click)="addAdditionalConfig()">
                    <span class="mr-2 text-lg">+</span> Añadir Día
                </button>

                <button type="button"
                    class="flex items-center justify-center p-1 text-sm font-bold text-red-600 bg-white border-2 border-red-600 rounded-xl hover:bg-red-600 hover:text-white disabled:opacity-30 disabled:grayscale transition-all duration-200"
                    (click)="removeAdditionalConfig()" [disabled]="configurationsArray.length === 0">
                    <span class="mr-2 text-lg">-</span> Eliminar Último Día
                </button>
            </div>
        </section>

    </form>
</app-custom-modal>
}